import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AgChartOptions } from 'ag-charts-community';
import { donutChartFills, getDataForBarChart } from 'src/app/shared/data/chart-data';
import { AppService } from 'src/app/app.service';
import { round } from 'ag-charts-community/dist/types/src/module-support';

@Component({
  selector: 'app-chart',
  standalone: false,
  templateUrl: './chart.component.html',
  styleUrl: './chart.component.scss'
})
export class ChartComponent implements OnInit, OnChanges {
  public options: AgChartOptions;
  @Input() type:string ='donut';
  @Input() info:any;
  public seriesData:any;
  constructor(public appService:AppService){
    if(this.type === 'donut'){
      this.options = {
        tooltip:{enabled:false},
        legend: {
          enabled:false,
          position: 'right' // Position the legend on the right
        }
        };
    }
    else{
      this.options ={
       legend:{
          enabled:true,
          position:'right'
        }
    }
    }
}

ngOnChanges(changes: SimpleChanges): void {
  this.info = changes['info'].currentValue;
  // this.info = this.info.data.reduce((acc:any,curr:any)=>acc+curr.amount,0)
}
  ngOnInit(): void {
    
    if(this.type === 'donut'){
      this.options.title = {
        text: this.info.title,
        textAlign:'left',
        fontSize:14,
      }
      this.options.data=this.info.data
      this.seriesData=  {
        type: "donut",
        calloutLabelKey: "asset",
        angleKey: "amount",
        innerRadiusRatio: 0.7,
        fills:this.appService.selectedTheme? donutChartFills:['#2A6BAC','#6D6D6D'],
        calloutLabel:{enabled:false},
        innerLabels:[{
          text:'Total\nAgreement',
          color:'black',
          fontSize:12,
          
        },
        {text:'\n'},
        {
          text:this.totalAgreementString(),
          color:'black',
          fontWeight:'bold',
          fontSize:14,
        },
      ],
        innerCircle: {
          fill: "white",
        },
      }
      this.options.series = [this.seriesData]
      if(this.info.data.every((item:any)=>item.amount === 0)){
        this.info.data[0].amount = 0.1  
        this.seriesData['fills'] = ['#cecece']
      }
    }
    else{
      this.options.data=getDataForBarChart();
      this.options.legend={enabled:true,position:'right'}
      this.options.title={
        text: 'Agreements by Carrier',
        fontWeight:'bold',
        fontFamily:'Times New Roman',
        fontSize:14,
        textAlign:'left'
      }
      this.options.series=[ {
        type: "bar",
        xKey: "quarter",
        xName:'Months',
        yKey: "iphone",
        yName: "No of Buyer",fill:'#D40511'
      },
      {
        type: "bar",
        xKey: "quarter",
        yKey: "mac",
        fill:'#5A4748',
        yName: "Mac",
      },
      {
        type: "bar",
        xKey: "quarter",
        yKey: "ipad",
        fill:'#878080',
        yName: "iPad",
      },
     ]
    }

   
   
  }

  totalAgreementString(): string {
  return this.info.totalAgreement.toString();
}

  getCount(data:any,name:string){
    return (data.find((item:any)=>item.asset === name)?.amount).toFixed();
  }

  getPercentage(data:any,name:string){
    if(data.totalAgreement === 0){
      return 0;
    }
    return Math.round((this.getCount(data.data,name)/data.totalAgreement)*100)
  }

}
